import clsx from 'clsx';
import { useState } from 'react';
import { Tooltip } from '@/components/ui/Tooltip';

type StarFavoriteIconSvgProps = {
  filled: boolean;
  className?: string;
};

const StarFavoriteIconSvg = ({ filled, className = '' }: StarFavoriteIconSvgProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx('text-[#1F4ED8]', className)}
    aria-hidden
  >
    <path
      d="M12 2L14.09 8.26L21 9.27L16 13.14L17.18 20.02L12 17.27L6.82 20.02L8 13.14L3 9.27L9.91 8.26L12 2Z"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinejoin="round"
      className="transition-[fill] duration-150"
    />
  </svg>
);

type StarFavoriteIconProps = {
  selected?: boolean;
  className?: string;
  onClick?: (ev: React.MouseEvent<HTMLSpanElement>) => void;
};

export const StarFavoriteIcon = ({ selected = false, className = '', onClick }: StarFavoriteIconProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isSelected, setIsSelected] = useState(selected);
  const tooltipText = isSelected ? 'Remove from favourite' : 'Add to Favourite';
  const showFilled = isHovered ? !isSelected : isSelected;

  const handleClick = (ev: React.MouseEvent<HTMLSpanElement>) => {
    setIsSelected(!isSelected);
    onClick?.(ev);
  };

  return (
    <Tooltip content={tooltipText} className="max-w-fit">
      <span
        className="inline-block cursor-pointer -mr-[7px]"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        role="img"
        aria-label={tooltipText}
        onClick={handleClick}
      >
        <StarFavoriteIconSvg filled={showFilled} className={className} />
      </span>
    </Tooltip>
  );
};
